const SAP = () => {
    return (
        <>SAP</>
    );
};

export default SAP;